<template lang="pug">
.dropdown
  a(
    v-tooltip
    :class="linkClasses"
    :disabled="disabled ? 'disabled' : null"
    :data-original-title="tooltip"
    data-placement="bottom"
    data-toggle="dropdown"
    role="button"
  )
    i(
      v-if="iconClasses"
      :class="iconClasses"
    )
    span {{ text }}
    i.hi.hi-caret-hi-10(v-if="!hideCaret")

  ul.dropdown-menu.dropdown-menu-right(v-if="!disabled")
    slot
</template>

<script>
export default {
  name: 'AppExportMenu',
  props: {
    text: {
      type: String,
      default: 'Export',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    disabledTooltip: {
      type: String,
      default: 'There is no data to export',
    },
    typeClasses: {
      type: String,
      default: '',
    },
    iconClasses: {
      type: String,
      default: '',
    },
    hideCaret: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    tooltip() {
      return this.disabled ? this.disabledTooltip : '';
    },
    linkClasses() {
      const iconClasses = this.iconClasses ? ' has-icon' : '';

      return `dropdown-toggle ${this.typeClasses}${iconClasses}`;
    },
  },
};
</script>
